<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-combobox
        v-model="choices"
        :items="tags"
        :rules="[rules.required]"
        :search-input.sync="search"
        :menu-props="{ closeOnContentClick: true }"
        hide-selected
        label="Tags"
        item-text="name"
        item-value="slug"
        multiple
        persistent-hint
        small-chips
        return-object
    >
        <template v-if="search && search.length >= 3" v-slot:no-data>
            <v-list-tile>
                <v-list-tile-content>
                    <v-list-tile-title>
                        Appuyez sur <kbd>enter</kbd> pour ajouter "<strong>{{ search }}</strong>"
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </template>
    </v-combobox>
</template>

<script>
    import {TAGS_FETCH} from "../../store/actions.type";
    import {mapGetters} from "vuex";

    export default {
        name: "TagsCombobox",
        props: {
            defaultValues: {
                type: Array,
                default: null
            }
        },
        data: () => ({
            choices: null,
            search: null,
            rules: {
                required: value => !!value || 'Champ requis',
            }
        }),
        computed: {
            ...mapGetters(["tags"])
        },
        mounted() {
            this.choices = this.defaultValues;
            this.$store.dispatch(TAGS_FETCH);
        }
    };
</script>

<style scoped lang="scss">
</style>
